/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createBackfillCallCustomersResultFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type BackfillCallCustomersResult, type ProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /backfills/call-customers
 */
export interface CallCustomersRequestBuilder extends BaseRequestBuilder<CallCustomersRequestBuilder> {
    /**
     * BackfillCallCustomers
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<BackfillCallCustomersResult>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     post(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<BackfillCallCustomersResult | undefined>;
    /**
     * BackfillCallCustomers
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const CallCustomersRequestBuilderUriTemplate = "{+baseurl}/backfills/call-customers";
/**
 * Metadata for all the requests in the request builder.
 */
export const CallCustomersRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: CallCustomersRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createBackfillCallCustomersResultFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
